// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {160: "c010f128",575: "219a253e",956: "e25fccab",}[chunkId] + ".js"
}